import { ShareWithUserPopupAction, ShareWithUserPopupActionKeys } from './actions';
import { Api } from '../../typings/api';

export interface ShareWithUserPopupState {
	isDisplayed: boolean;
	isLoading: boolean;
	users: Api.ShareUser[];
	selectedUserId: number | null;
	resourceGId: number | null;
}

const shareWithUserPopupInitialState: ShareWithUserPopupState = {
	isDisplayed: false,
	isLoading: false,
	users: [],
	selectedUserId: null,
	resourceGId: null,
};

export const shareWithUserPopup = (state: ShareWithUserPopupState = shareWithUserPopupInitialState, action: ShareWithUserPopupAction): ShareWithUserPopupState => {
	switch (action.type) {
		case ShareWithUserPopupActionKeys.GET_USERS:
			return {
				...state,
				resourceGId: action.resourceGId,
				isDisplayed: true,
				isLoading: true,
			};
		case ShareWithUserPopupActionKeys.SET_USERS:
			return {
				...state,
				users: action.users,
				selectedUserId: action.users[0] ? action.users[0].id : null,
				isLoading: false,
			};
		case ShareWithUserPopupActionKeys.SELECT_USER:
			return {
				...state,
				selectedUserId: action.userId,
			};
		case ShareWithUserPopupActionKeys.RESET:
			return shareWithUserPopupInitialState;
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ShareWithUserPopup/reducer.ts